// Reusable 4x6 Grove multi-SKU pallet label (repeating SKU pairs, GS1-128 Pallet SSCC).
// Generated by scripts/wms/generate.ts for PHP-416. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGroveMultiSkuPalletLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  groveFcLocation: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  grovePoNumber: yup.string().nullable().optional(),
  grossWeight: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  palletSequence: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  palletContents: yup
    .array()
    .of(
      yup.object().shape({
        vendorItemNumber: yup.string().nullable().optional(),
        groveSkuNumber: yup.string().nullable().optional(),
      }),
    )
    .required(),
  palletSscc: yup.string().nullable().optional(),
  palletSsccBarcode: yup.string().nullable().optional(),
})

export type BiomGroveMultiSkuPalletLabelFileData = yup.InferType<
  typeof biomGroveMultiSkuPalletLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomGroveMultiSkuPalletLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGroveMultiSkuPalletLabelFileMappings: RequiredFileData = {
  customerDisplayName: '3604542b-6fa6-465a-bbef-cd32b4eb99f8',
  shipFromAddress: '6a30ee55-c410-412d-8ab1-c57eb0157433',
  groveFcLocation: '851e5139-013a-41a4-9873-a40189253487',
  shipToAddress: '89adb919-5987-46c3-b4b7-e4cb32f0df9e',
  grovePoNumber: 'deaefa74-3119-4d28-ade0-3eb43c033902',
  grossWeight: '74109af3-6f53-44dc-9518-73b1243201c2',
  weightUom: '1beb8b66-b9c4-42b6-acab-11b201ed3674',
  palletSequence: '5c7e7112-1287-4f3d-b887-e99b1707861a',
  palletCount: 'fdc087bb-9325-4e00-b5a8-43a317c2f1a2',
  palletContents: [
    {
      vendorItemNumber: 'e219a05a-d579-4925-bb50-12084a1c6a1b',
      groveSkuNumber: '05ad5358-47fb-419a-ac53-0c169aea81ae',
    },
  ],
  palletSscc: '4c1f4a62-7845-42c3-937f-8b58126fb241',
  palletSsccBarcode: '3f09d626-c688-493e-a801-77059f29fa42',
}
